import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { get, map } from "lodash"
import { withTranslation } from "react-i18next"

//i18n
import i18n from "../../../i18n"
import languages from "../../../common/languages"
import map1 from "../../../assets/images/map1.png"

const LanguageDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [selectedLang, setSelectedLang] = useState("")
  const [menu, setMenu] = useState(false)
  const [showComingSoon, setShowComingSoon] = useState(false)
  const timerRef = React.useRef(null)

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE")
    setSelectedLang(currentLanguage)
    // avoid extra logs and runs; run once on mount
  }, [])

  const changeLanguageAction = lang => {
    //set language as i18n
    i18n.changeLanguage(lang)
    localStorage.setItem("I18N_LANGUAGE", lang)
    setSelectedLang(lang)
  }

  const handleLanguageClick = langKey => {
    // If Spanish (sp) is clicked, show a small anchored panel instead of switching
    if (langKey === 'sp') {
      setShowComingSoon(true)
      // auto-hide after 2s
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => setShowComingSoon(false), 2000)
      // close dropdown if open
      setMenu(false)
      return
    }
    changeLanguageAction(langKey)
    setMenu(false)
  }

  // cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  const toggle = () => {
    setMenu(!menu)
  }

  return (
    <>
      {/* Inline CSS for the small anchored panel animation (keeps change local to component) */}
      <style>{`
        @keyframes comingSoonFadeSlide {
          from { opacity: 0; transform: translateY(-6px) translateX(6px); }
          to { opacity: 1; transform: translateY(0) translateX(0); }
        }
        .coming-soon-panel {
          animation: comingSoonFadeSlide 220ms cubic-bezier(.2,.9,.3,1) both;
        }
      `}</style>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block language-switch" style={{ position: 'relative' }}>
        <DropdownToggle className="btn header-item waves-effect" tag="button">
          <div className="kq-icon-pill" style={{ width: "fit-content" }}>
            <img
              src={map1}
              alt="Language"
              style={{ width: "18px", height: "18px", flexShrink: 0 }}
            />
            <span className="text-white" style={{ textTransform: "uppercase", fontSize: 11, fontWeight: 600 }}>{selectedLang}</span>
          </div>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end" end>
          {map(Object.keys(languages), key => (
            <DropdownItem
              key={key}
              onClick={() => handleLanguageClick(key)}
              className={`notify-item ${selectedLang === key ? "active" : "none"
                }`}
            >
              <img
                src={get(languages, `${key}.flag`)}
                alt="Minible"
                className="me-1"
                height="12"
              />
              <span className="align-middle">{get(languages, `${key}.label`)}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>

        {/* Small anchored panel shown when Spanish is clicked (near the language toggle) */}
        {showComingSoon && (
          <div
            role="dialog"
            aria-label="Language coming soon"
            onClick={(e) => e.stopPropagation()}
            className="coming-soon-panel"
            style={{
              position: 'absolute',
              top: 48,
              right: 0,
              minWidth: 160,
              background: '#1F2230',
              color: '#E7E9EF',
              border: '1px solid #2E3244',
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
              padding: '8px 12px',
              fontSize: 13,
              zIndex: 1200,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 14 }}>Coming soon</div>
          </div>
        )}
      </Dropdown>
    </>
  )
}

export default withTranslation()(LanguageDropdown)
